


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyANrJVmNfIzfdADwnlYpjsZbTvna16JVuA",
  authDomain: "batticaloa-opticals.firebaseapp.com",
  projectId: "batticaloa-opticals",
  storageBucket: "batticaloa-opticals.firebasestorage.app",
  messagingSenderId: "58160689930",
  appId: "1:58160689930:web:f68dd3c15dbfd51600c0f3"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export